import { render } from "./ContentRating.vue?vue&type=template&id=f76a7dd0&scoped=true&ts=true"
import script from "./ContentRating.vue?vue&type=script&lang=ts"
export * from "./ContentRating.vue?vue&type=script&lang=ts"

import "./ContentRating.vue?vue&type=style&index=0&id=f76a7dd0&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f76a7dd0"]])

export default __exports__